<template>
    <v-card
        class="mt-4 mx-auto"
        flat
        >
        <v-alert
            v-if="!hasValues()"
            color="info"
            >Não há dados no período</v-alert>
        <v-sheet
            class="v-sheet mx-auto"
            color="#FFFFFF"
            elevation="12"
            max-width="calc(100% - 10px)"
            >
            <v-sparkline
                :labels="labels"
                :value="value"
                color="cyan"
                line-width="1"
                padding="15"
                label-size="5"
                height="130%"
                >
                <template v-slot:label="item"
                          class="label"
                          > {{ parseToShow(item) }} </template>
            </v-sparkline>
        </v-sheet>
        <v-divider></v-divider>
    </v-card>
</template>

<script>
    import axios from "axios";
    import { requestTools } from "../mixins/requestTools.js";
    import { dateTimeTools } from "../mixins/dateTimeTools.js";
    export default {
        name: "PoiRegChart",
        props: {
            tags: String,
            dateBegin: String,
            dateEnd: String
        },
        mixins: [requestTools, dateTimeTools],
        data: function () {
            return {
                labelLimit: 11,
                labelShowChangeDayLimit: 4,
                values: [],
                labels: [],
                value: [],
                lastDay: "",
                daysDiff: 0
            }
        },
        created: async function () {
            await this.loadData();
            this.parseRawData();
        },
        methods: {

            parseToShow(item) {

                if (item.value == "false") {
                    return "";
                }

                if (item.value.indexOf(":") === -1) {
                    return "";
                }

                return item.value;
            },

            async loadData() {

                const url = process.env.VUE_APP_ROOT_API + "/poi/histData"
                        + "/" + this.tags
                        + "/" + this.parseBeginEndData(this.dateBegin, "begin")
                        + "/" + this.parseBeginEndData(this.dateEnd, "end");

                const response = await this.requestGet(url);
                this.values = response.data;
            },

            calcTick(lim = 10) {
                return parseInt(Math.floor(this.values.length / lim));
            },

            calcDaysDiff() {
                this.daysDiff = this.diffInDays(this.dateBegin, this.dateEnd);
            },

            parseRawData() {

                const labelsTmp = [];
                const dateTimesAdded = [];
                this.calcDaysDiff();

                if (this.daysDiff > this.labelShowChangeDayLimit) {
                    this.labelLimit = 19;
                }

                this.values.map((data) => {

                    /*
                     * Se houver datas repetidas, o gráfico fica desproporcional.
                     * Portanto é necessário fazer esse controle
                     */
                    if (dateTimesAdded.indexOf(data.updatedAt) === -1) {
                        this.value.push(parseFloat(data.value));
                        dateTimesAdded.push(data.updatedAt);
                    }

                    /*
                     * Add Label
                     */
                    if (labelsTmp.indexOf(data.updatedAt) === -1) {
                        labelsTmp.push(data.updatedAt);
                    }
                });
                /*
                 * Parse Label
                 */
                const lastI = labelsTmp.length - 2;
                let i = 0;
                let jumpC = 0;
                this.labels = [];
                const tickJump = this.calcTick(this.labelLimit);
                labelsTmp.map((labelI) => {
                    let labelFinal = (i === 0 || jumpC === tickJump)
                            ? this.makeLabelFromDate(labelI)
                            : "false";
                    jumpC = (labelFinal !== "false") ? 0 : jumpC + 1;
                    this.labels.push(labelFinal);
                    i++;
                });
            },

            makeLabelFromDate(dateStr) {

                let labelTx = "";

                const dt = new Date(dateStr);

                let day = dt.getDate().toString().padStart(2, "0");
                let month = (1 + dt.getMonth()).toString().padStart(2, "0");
                let time = dt.getHours().toString().padStart(2, "0");
                time += ":" + dt.getMinutes().toString().padStart(2, "0");

                if (this.daysDiff <= this.labelShowChangeDayLimit && day != this.lastDay) {
                    labelTx += day;
                    labelTx += "/" + month;
                }

                labelTx += " " + time;

                this.lastDay = day;

                return labelTx;
            },

            hasValues() {
                return this.values.length > 0;
            }
        }
    };
</script>

<style>
    .v-sheet--offset {
        top: -24px;
        position: relative;
    }

    .label {
        /* transform: rotate(45deg); /* Equal to rotateZ(45deg) */
    }
</style>